"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: transfer/recurring-transfer-date.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftransfer%2Frecurring-transfer-date.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.recurringTransferDateStatusToJSON = exports.recurringTransferDateStatusFromJSON = exports.RecurringTransferDate = exports.RecurringTransferDateStatus = void 0;
const date_1 = require("../common/date");
const protobufPackage = 'com.step.transfer.proto';
var RecurringTransferDateStatus;
(function (RecurringTransferDateStatus) {
    RecurringTransferDateStatus["INVALID_RECURRING_TRANSFER_DATE_STATUS"] = "INVALID_RECURRING_TRANSFER_DATE_STATUS";
    RecurringTransferDateStatus["PENDING"] = "PENDING";
    RecurringTransferDateStatus["SHOULD_SKIP"] = "SHOULD_SKIP";
    RecurringTransferDateStatus["SKIPPED"] = "SKIPPED";
    RecurringTransferDateStatus["SUCCESS"] = "SUCCESS";
    RecurringTransferDateStatus["FAILED"] = "FAILED";
    RecurringTransferDateStatus["IN_PROGRESS"] = "IN_PROGRESS";
    RecurringTransferDateStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(RecurringTransferDateStatus || (exports.RecurringTransferDateStatus = RecurringTransferDateStatus = {}));
function createBaseRecurringTransferDate() {
    return {
        id: '',
        recurringTransferId: '',
        status: RecurringTransferDateStatus.INVALID_RECURRING_TRANSFER_DATE_STATUS,
        transferAt: date_1.DateMessage.fromPartial({}),
        initiateAt: date_1.DateMessage.fromPartial({}),
    };
}
exports.RecurringTransferDate = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            recurringTransferId: isSet(object.recurringTransferId)
                ? globalThis.String(object.recurringTransferId)
                : '',
            status: isSet(object.status)
                ? recurringTransferDateStatusFromJSON(object.status)
                : RecurringTransferDateStatus.INVALID_RECURRING_TRANSFER_DATE_STATUS,
            transferAt: isSet(object.transferAt)
                ? date_1.DateMessage.fromJSON(object.transferAt)
                : date_1.DateMessage.fromPartial({}),
            initiateAt: isSet(object.initiateAt)
                ? date_1.DateMessage.fromJSON(object.initiateAt)
                : date_1.DateMessage.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.recurringTransferId !== '') {
            obj.recurringTransferId = message.recurringTransferId;
        }
        if (message.status !== RecurringTransferDateStatus.INVALID_RECURRING_TRANSFER_DATE_STATUS) {
            obj.status = recurringTransferDateStatusToJSON(message.status);
        }
        if (message.transferAt !== undefined) {
            obj.transferAt = date_1.DateMessage.toJSON(message.transferAt);
        }
        if (message.initiateAt !== undefined) {
            obj.initiateAt = date_1.DateMessage.toJSON(message.initiateAt);
        }
        return obj;
    },
    create(base) {
        return exports.RecurringTransferDate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringTransferDate();
        message.id = object.id ?? '';
        message.recurringTransferId = object.recurringTransferId ?? '';
        message.status = object.status ??
            RecurringTransferDateStatus.INVALID_RECURRING_TRANSFER_DATE_STATUS;
        message.transferAt = (object.transferAt !== undefined && object.transferAt !== null)
            ? date_1.DateMessage.fromPartial(object.transferAt)
            : date_1.DateMessage.fromPartial({});
        message.initiateAt = (object.initiateAt !== undefined && object.initiateAt !== null)
            ? date_1.DateMessage.fromPartial(object.initiateAt)
            : date_1.DateMessage.fromPartial({});
        return message;
    },
};
function recurringTransferDateStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_RECURRING_TRANSFER_DATE_STATUS':
            return RecurringTransferDateStatus.INVALID_RECURRING_TRANSFER_DATE_STATUS;
        case 1:
        case 'PENDING':
            return RecurringTransferDateStatus.PENDING;
        case 2:
        case 'SHOULD_SKIP':
            return RecurringTransferDateStatus.SHOULD_SKIP;
        case 3:
        case 'SKIPPED':
            return RecurringTransferDateStatus.SKIPPED;
        case 4:
        case 'SUCCESS':
            return RecurringTransferDateStatus.SUCCESS;
        case 5:
        case 'FAILED':
            return RecurringTransferDateStatus.FAILED;
        case 6:
        case 'IN_PROGRESS':
            return RecurringTransferDateStatus.IN_PROGRESS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return RecurringTransferDateStatus.UNRECOGNIZED;
    }
}
exports.recurringTransferDateStatusFromJSON = recurringTransferDateStatusFromJSON;
function recurringTransferDateStatusToJSON(object) {
    switch (object) {
        case RecurringTransferDateStatus.INVALID_RECURRING_TRANSFER_DATE_STATUS:
            return 'INVALID_RECURRING_TRANSFER_DATE_STATUS';
        case RecurringTransferDateStatus.PENDING:
            return 'PENDING';
        case RecurringTransferDateStatus.SHOULD_SKIP:
            return 'SHOULD_SKIP';
        case RecurringTransferDateStatus.SKIPPED:
            return 'SKIPPED';
        case RecurringTransferDateStatus.SUCCESS:
            return 'SUCCESS';
        case RecurringTransferDateStatus.FAILED:
            return 'FAILED';
        case RecurringTransferDateStatus.IN_PROGRESS:
            return 'IN_PROGRESS';
        case RecurringTransferDateStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.recurringTransferDateStatusToJSON = recurringTransferDateStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=recurring-transfer-date.js.map